// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__k-F5C"};